import(/* webpackMode: "eager" */ "/opt/build/repo/application/src/app/global-error.tsx");
